module.exports = __webpack_public_path__ + "static/media/email-icon.1c4a706d.png";